import { request } from "../request";

export enum KnowledgeBaseTypeEnum {
  Public = 1,
  Private,
}

export enum HighLevelKnowledgeDataTypeEnum {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  DATE = "DATE",
}

export enum SmartKnowledgebaseTypeEnum {
  RawText = "rawText",
  Entity = "entity",
  Relation = "relation",
  Cluster = "cluster",
}

export type FormColumnsItemType = {
  title: string;
  dataIndex: string;
  valueType: string;
  width: string;
};

export enum KnowledgeSourceTypeEnum {
  Manual = 1,
  Import,
}
export enum DatasetStructure {
  /** 普通知识库 */
  Normal = 1,
  /** 高级知识库 */
  Advance = 2,
  /** 智能知识库 */
  Smart = 3,
}

export const DatasetOptions = [
  {
    label: "普通知识库",
    value: DatasetStructure.Normal,
  },
  {
    label: "智能知识库",
    value: DatasetStructure.Smart,
  },
];
/**
 * 获取知识库列表
 * @param data
 * @returns
 */
export function getKnowledgebaseListService(data: {
  pageNum: number;
  pageSize: number;
  structure: DatasetStructure;
  flowId: string;
  baseName?: string;
}) {
  return request<
    API.BaseResponse<{
      records: KnowledgebaseDetailType[];
      total: number;
      size: number;
      current: number;
    }>
  >("/api/knowledge-base-management/base/pageBase", {
    method: "POST",
    data,
  });
}

export type KnowledgebaseDetailType = {
  id: string;
  name: string;
  description: string;
  type: KnowledgeBaseTypeEnum;
  embeddingModel: string;
  canOpera: boolean;
  isDeleted: number;
  structure: DatasetStructure;
};
/**
 * 新增知识库
 * @param data
 * @returns
 */
export function createKnowledgebaseService(
  data: Partial<KnowledgebaseDetailType>
) {
  return request<API.BaseResponse<string>>(
    "/api/knowledge-base-management/base/saveBase",
    {
      method: "POST",
      data,
    }
  );
}
/**
 * 更新知识库信息
 * @param data
 * @returns
 */
export function updateKnowledgebaseService(
  data: Partial<KnowledgebaseDetailType>
) {
  return request<API.BaseResponse<string>>(
    "/api/knowledge-base-management/base/updateBase",
    {
      method: "POST",
      data,
    }
  );
}

export type KnowledgeRecordItemType = {
  id: string;
  indexContent: string;
  baseContent: string;
  source: KnowledgeSourceTypeEnum;
  metadataInfo: string;
  score: number;
};

/**
 * 分页搜索baseId下的知识
 * @param data
 * @returns
 */
export function getRecordListService(data: {
  pageNum: number;
  pageSize: number;
  baseId: string;
  conditions?: conditionsType;
}) {
  return request<
    API.BaseResponse<{
      records: KnowledgeRecordItemType[];
      total: number;
      size: number;
      current: number;
    }>
  >("/api/knowledge-base-management/knowledge/pageKnowledge", {
    method: "POST",
    data,
  });
}
/** 查询是否知识是否已经导入完了 true就是导入完了，false就是没完 */
export function getResultByBaseId(baseId: string) {
  return request<API.BaseResponse<boolean>>(
    "/api/knowledge-base-management/knowledge/getResultByBaseId",
    {
      method: "GET",
      params: {
        baseId,
      },
    }
  );
}
export enum SearchType {
  Semantic = 1,
  FullTest,
  Hybrid,
}
export type conditionsType = {
  fieldName: string;
  operator: string;
  value: string;
}[];

export type TestSearchParamsType = {
  baseId: string;
  keyword: string;
  score: number;
  searchStrategy: number; //查询策略 1-无结果时返回相关度最高一条
  searchType: SearchType;
  size: number; //最大条数
  wordNum: number; //最大字数上限
  structure: DatasetStructure;
};
export type HighLevelTestSearchParamsType = {
  baseId: string;
  score: number;
  searchStrategy: number; //查询策略 1-无结果时返回相关度最高一条
  searchType: SearchType;
  size: number; //最大条数
  wordNum: number; //最大字数上限
  conditions: conditionsType;
  structure: DatasetStructure;
};
export type TestSearchItemType = {
  id: number;
  indexContent: string;
  baseContent: string;
  source: KnowledgeSourceTypeEnum;
  metadataInfo: string;
  score: number;
  fieldMap: Record<string, string>;
};
/**
 * 测试搜索 查询知识库知识
 * @param params
 * @returns
 */
export function getTestSearchService(
  data: Partial<TestSearchParamsType | HighLevelTestSearchParamsType>
) {
  return request<
    API.BaseResponse<{
      maxScoreVoList: TestSearchItemType[];
      voList: TestSearchItemType[];
    }>
  >("/api/knowledge-base-management/knowledge/search4User", {
    method: "POST",
    data,
  });
}
export type KnowledgeRecordType = {
  id: number;
  indexContent: string;
  baseContent: string;
  userId: string;
  baseId: string;
  type: number;
  embeddingModel: string;
  indexVector: [];
  source: KnowledgeSourceTypeEnum;
  metadataInfo: string;
};
/**
 * 手动新增知识
 * @param data
 * @returns
 */
export function saveKnowledgeService(
  data: Partial<KnowledgeRecordType & { createdGmt: string }>
) {
  return request<API.BaseResponse<null>>(
    "/api/knowledge-base-management/knowledge/saveKnowledge",
    {
      method: "POST",
      data,
    }
  );
}

/**
 * 编辑更新知识
 * @param data
 * @returns
 */
export function updateKnowledgeService(
  data: Partial<KnowledgeRecordType & { createdGmt: string }>
) {
  return request<API.BaseResponse<null>>(
    "/api/knowledge-base-management/knowledge/updateKnowledge",
    {
      method: "POST",
      data,
    }
  );
}
/**
 * 删除知识
 * @param id
 * @returns
 */
export function deleteKnowledgeService(data: {
  ids: string[];
  baseId: string;
  deleteAllFromSource?: boolean;
}) {
  return request<API.BaseResponse<null>>(
    "/api/knowledge-base-management/knowledge/deleteKnowledge",
    {
      method: "POST",
      data,
    }
  );
}

export type importKnowledgeType = {
  baseId: string;
  file: FormData;
  line?: boolean;
  maxSize?: number;
  splitterMark?: string;
};
export type splitPreviewList = {
  modelList: Array<KnowledgeRecordType & { createdGmt: string }>;
  splitId: string;
  blankIndexFlag: boolean;
};
/**
 * 导入文件知识获取分割预览
 * @param data
 * @returns
 */
export function importKnowledgePreviewService(data: importKnowledgeType) {
  return request<API.BaseResponse<splitPreviewList>>(
    "/api/knowledge-base-management/knowledge/importKnowledgeSplit",
    {
      method: "POST",
      data,
    }
  );
}

/**
 * 导入知识文件-落库
 * @param data
 * @returns
 */
export function importKnowledgeToDBService(splitId: string) {
  return request<API.BaseResponse<{ repeatFlag: boolean }>>(
    "/api/knowledge-base-management/knowledge/importKnowledge2DB",
    {
      method: "POST",
      params: {
        splitId,
      },
    }
  );
}

/**
 * 获取全部模型
 */
export function queryAllModelService() {
  return request<API.BaseResponse<string[]>>(
    "/api/knowledge-base-management/base/allModel"
  );
}

export type checkImportHighKnowledgeResultType = API.BaseResponse<{
  splitId: string;
  modelList: any[];
  blankIndexFlag: boolean;
  repeatFlag: boolean;
  fieldNameList: string[];
}>;
/**
 * 第一次导入高级知识库-上传知识文件
 */
export function checkImportHighKnowledgeService(baseId: string, file: File) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("baseId", baseId);
  return request<checkImportHighKnowledgeResultType>(
    "/api/knowledge-base-management/knowledge/checkImportHighKnowledge",
    {
      method: "POST",
      data: fd,
    }
  );
}

/**
 * 第n次导入高级知识库-上传知识文件
 */
export function importHighKnowledgeSecondService(baseId: string, file: File) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("baseId", baseId);
  return request<checkImportHighKnowledgeResultType>(
    "/api/knowledge-base-management/knowledge/importHighKnowledgeSecond",
    {
      method: "POST",
      data: fd,
    }
  );
}

export type colItem = {
  fieldName: string;
  needEmbedding: boolean;
  type: HighLevelKnowledgeDataTypeEnum;
};
type importHighKnowledgeFirstParams = {
  baseId: string;
  propertyInfoList: colItem[];
  splitId: string;
};
/** 第一次导入高级知识库-导入 */
export function importHighKnowledgeFirstService(
  data: importHighKnowledgeFirstParams
) {
  return request<API.BaseResponse<{ repeatFlag: boolean }>>(
    "/api/knowledge-base-management/knowledge/importHighKnowledgeFirst",
    {
      method: "POST",
      data,
    }
  );
}

/** 根据高级知识库Id查询对应的字段 */
export function findFieldByBaseId(baseId: string) {
  return request<API.BaseResponse<colItem[]>>(
    "/api/knowledge-base-management/knowledge/findFieldByBaseId",
    {
      params: { baseId },
    }
  );
}
export type pageSearchParamType = {
  fieldOperator: string;
  fieldType: string;
  options: { paramValue: string; showValue: string }[];
  paramName: string;
  showName: string;
};
export enum SmartDataTypeEnum {
  RAW_TEXT = "RAW_TEXT",
  ENTITY = "ENTITY",
  RELATION = "RELATION",
  CLUSTER = "CLUSTER",
}
/** 获取知识列表查询的字段参数 */
export function qeuryPageSearchParamService(params: {
  baseId: string;
  dataType?: SmartDataTypeEnum;
}) {
  return request<API.BaseResponse<pageSearchParamType[]>>(
    "/api/knowledge-base-management/base/pageSearchParam",
    {
      params,
    }
  );
}

export interface ISmartKnowledgeDetail {
  id: string;
  name: string;
  description: string;
  source: KnowledgeSourceTypeEnum;
  metadataInfo: string[];
}

/**
 * 上传智能知识库地址
 */
export const UPLOAD_SMART_URL =
  "/api/knowledge-base-management/knowledge/smart/upload";

interface IPostImportSmartKnowledgeData {
  baseId: string;
  chunkSize: number;
  overlap: number;
  docLinks: string[];
}

/**
 * 导入智能知识库
 * @param data
 * @returns
 */
export function postImportSmartKnowledge(data: IPostImportSmartKnowledgeData) {
  return request<API.BaseResponse>(
    "/api/knowledge-base-management/knowledge/smart/importFileList",
    {
      method: "POST",
      data,
    }
  );
}

interface IPostSmartRecordListData {
  pageSize: number;
  pageNum: number;
  dataType: string;
  baseId: string;
  conditions?: conditionsType;
}

interface IPostSmartRecordListResponse {
  current: number;
  pages: number;
  size: number;
  total: number;
  records: {
    id: string;
    metadataInfo: string;
    source: number;
    fieldMap: {
      name: string;
      description?: string;
      chunkId: string[];
    };
  }[];
}

/**
 * 获取智能知识库列表
 * @param data
 * @returns
 */
export function postSmartRecordList(data: IPostSmartRecordListData) {
  return request<API.BaseResponse<IPostSmartRecordListResponse>>(
    "/api/knowledge-base-management/knowledge/pageKnowledge",
    {
      method: "POST",
      data,
    }
  );
}

interface IPostSearchSmartKnowledgeData {
  baseId: string;
  keyword: string;
  score: number;
  searchType: number;
  size: number;
  structure: number;
  wordNum: number;
}

export interface IPostSearchSmartKnowledgeResponseData {
  fieldMap: {
    name: string;
    chunkId: string[];
    description?: string;
  };
  id: string;
  score: number;
  source: number;
}

export interface IPostSearchSmartKnowledgeResponse {
  clusterList: IPostSearchSmartKnowledgeResponseData[];
  entityList: IPostSearchSmartKnowledgeResponseData[];
  rawTextList: IPostSearchSmartKnowledgeResponseData[];
  relationList: IPostSearchSmartKnowledgeResponseData[];
}

/**
 * 搜索智能知识库
 * @param data
 * @returns
 */
export function postSearchSmartKnowledge(data: IPostSearchSmartKnowledgeData) {
  return request<API.BaseResponse<IPostSearchSmartKnowledgeResponse>>(
    "/api/knowledge-base-management/knowledge/smart/search",
    {
      method: "POST",
      data,
    }
  );
}

interface IPostSaveOrUpdateSmartKnowledgeData extends ISmartKnowledgeDetail {
  baseId: string;
  dataType: `${SmartKnowledgebaseTypeEnum}`;
}

/**
 * 手动添加/更新数据
 * @param data
 * @returns
 */
export function postSaveOrUpdateSmartKnowledge(
  data: IPostSaveOrUpdateSmartKnowledgeData
) {
  return request(
    "/api/knowledge-base-management/knowledge/smart/saveOrUpdateKnowledge",
    {
      method: "POST",
      data,
    }
  );
}
